export const devLogos=[
    {
     orgId:1,
     logoPath:"assets/images/mq_logo.png",
     orgLogo:"assets/images/logo.png",
     isOrg:true,
     orgText:'© 2025 Powered By MQPro. All Rights Reserved.',
     logoName:'MQPro'
    },
    {
        orgId:0,
        logoPath:"assets/images/default_logo.png",
        orgLogo:"assets/images/default.png",
        isOrg:false,
        orgText:'© 2025 Powered By Tibil Solutions. All Rights Reserved.',
        logoName:'Tibil'
    },
    {
        orgId:2,
        logoPath:"assets/images/default_logo.png",
        orgLogo:"assets/images/default.png",
        isOrg:false,
        orgText:'© 2025 Powered By Tibil Solutions. All Rights Reserved.',
        logoName:'Tibil Finance'
    },
    {
        orgId:3,
        logoPath:"assets/images/default_logo.png",
        orgLogo:"assets/images/default.png",
        isOrg:false,
        orgText:'© 2025 Powered By Tibil Solutions. All Rights Reserved.',
        logoName:'Tibil Finance'
    },
    {
        orgId:4,
        logoPath:"assets/images/default_logo.png",
        orgLogo:"assets/images/default.png",
        isOrg:false,
        orgText:'© 2025 Powered By Tibil Solutions. All Rights Reserved.',
        logoName:'Tibil Finance'
    },
    {
        orgId:5,
        logoPath:"assets/images/default_logo.png",
        orgLogo:"assets/images/default.png",
        isOrg:false,
        orgText:'© 2025 Powered By Tibil Solutions. All Rights Reserved.',
        logoName:'Tibil '
    }
]